var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.pmid)?_c('xref',{attrs:{"name":"pubmed","accession":_vm.pmid,"url":'https://pubmed.ncbi.nlm.nih.gov/' + _vm.pmid}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }